/*
**************************** 
홈페이지 톡톡 플러스+
*****************************
*/

import React from "react";

function PlayTab() {
    return (
        <div>
            <section className="content-wrap tab-content on" id="play">
                <section className="img-wrap">
                    <img className="w-100 img-fluid" src="/img/play_m.jpg" alt="" />
                </section>
            </section>
        </div>
    )
}

function EnglishTab() {
    return (
        <div>
            <section className="content-wrap tab-content on" id="english">
                <section className="img-wrap">
                    <img className="w-100 img-fluid" src="/img/english_m.jpg" alt="" />
                </section>
            </section>
        </div>
    )
}

function MathTab() {
    return (
        <section className="content-wrap tab-content on" id="math">
            <section className="img-wrap">
                <img className="w-100 img-fluid" src="/img/math_m.jpg" alt="" />
            </section>
        </section>
    )
}

function ReadingTab() {
    return (
        <section className="content-wrap tab-content on" id="reading">
            <section className="img-wrap">
                <img className="w-100 img-fluid" src="/img/reading_m.jpg" alt="" />
            </section>
        </section>
    )
}

export default function Programs() {
    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">톡톡박스</a></li>
                    <li className="breadcrumb-item active small">톡톡스쿨</li>
                </ol>
            </div>

            <div className="container">
                <main className=".main">
                    <ul className="nav nav-tabs " role="tablist">
                        <li className="nav-item medium" role="presentation">
                            <a className="nav-link active text-muted text-decoration-none" data-bs-toggle="tab" href="#play" aria-selected="true" role="tab" tabindex="-1">놀이교육</a>
                        </li>
                        <li className="nav-item medium" role="presentation">
                            <a className="nav-link text-muted text-decoration-none" data-bs-toggle="tab" href="#english" aria-selected="false" role="tab" tabindex="-1">영어</a>
                        </li>
                        <li className="nav-item medium" role="presentation">
                            <a className="nav-link text-muted text-decoration-none" data-bs-toggle="tab" href="#math" aria-selected="false" tabindex="-1" role="tab">수학</a>
                        </li>
                        <li className="nav-item medium" role="presentation">
                            <a className="nav-link text-muted text-decoration-none" data-bs-toggle="tab" href="#read" aria-selected="false" tabindex="-1" role="tab">독서</a>
                        </li>
                    </ul>
                    <div id="myTabContent" className="tab-content">
                        <div className="tab-pane  active show" id="play" role="tabpanel">
                            <PlayTab></PlayTab>
                        </div>
                        <div className="tab-pane fade" id="english" role="tabpanel">
                            <EnglishTab></EnglishTab>
                        </div>
                        <div className="tab-pane fade" id="math" role="tabpanel">
                            <MathTab></MathTab>
                        </div>
                        <div className="tab-pane fade" id="read" role="tabpanel">
                            <ReadingTab></ReadingTab>
                        </div>
                    </div>
                </main>
            </div>
        </div>
    )
}